<template>

  <div class="row">
    <div class="col-md-12">
      <div class="card card-custom">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-list"></i>
            All Students
          </h3>
          <div class="card-tools" style="margin-top:10px">
            <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-4" v-for="item in students" :key="item.StudentID">

              <!-- Profile Image -->
              <div class="card card-custom card-outline clickable-card" v-on:click="switchStudent(item.StudentID)">
                <div class="ribbon-wrapper" v-if="item.IsSelected">
                  <div class="ribbon bg-success">
                    Selected
                  </div>
                </div>
                <div class="card-body box-profile">
                  <div class="text-center">
                    <img class="profile-user-img img-fluid img-circle" :src="item.Image">
                  </div>
                  <h3 class="profile-username text-center">{{item.Name}}</h3>
                  <p class="text-muted text-center">{{item.FatherName}}</p>
                  <p class="text-muted text-center">{{item.AdmissionNo}}</p>
                  <p class="text-muted text-center">{{item.DateOfBirth}}</p>
                  <p class="text-muted text-center">{{item.Class}}</p>
                  <p class="text-muted text-center">{{item.Section}}</p>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
              <!-- /.card -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    name: 'dashboard',

    data() {
      return {
        students: [],
      }

    },
    created() {
      this.pageLoad();
    },
    methods: {

      //show up list of data form in table from database
      pageLoad() {
        var vm = this;
        axios.post('/api/PortalApi/pageLoadSwitchStudent')
          .then(function (res) {
            vm.students = res.data.students;
          });
      },

      switchStudent: function (id) {
        var vm = this;
        axios.post('/api/PortalApi/switchStudent?id=' + id)
          .then(function (response) {
            window.location.reload();
          })
      },

    }
  }</script>

<style>
  .btn-action {
    margin-bottom: 4px;
  }

  .crs-title {
    border-bottom: 1px dashed black;
    padding-bottom: 10px;
  }
  .clickable-card {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

    .clickable-card:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

</style>



// WEBPACK FOOTER //
// src/components/switchStudent.vue